import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

type SignUpInput = {
  email: string;
};

export const signUpMutationAtom = createMutationAtomFactory(
  'authentication.signUp',
  ({ email }: SignUpInput) => ({
    authenticationSignUp: {
      __args: {
        email,
      },
      __typename: true,
      on_SignUpInitiatedResult: {
        token: true,
        email: true,
        success: true,
      },
      // Don't query email field on error to avoid field conflict with SignUpInitiatedResult
      on_InvalidCredentialsError: {
        __typename: true,
      },
    },
  }),
  { skipQueue: true }, // Skip queue for auth mutations
);
